
export const UploadImage = {
    methods: {
        getDataUri(url, callback){
            let image = new Image()

            image.onload = () => {
                let canvas = document.createElement('canvas');
                canvas.width = this.naturalWidth
                canvas.height = this.naturalHeight
                canvas.getContext('2d').drawImage(this, 0, 0)
                callback(canvas.toDataUrl('image/png').replace(/^data:image\/(png|jpg);base64,/, ''))
                callback(canvas.toDataURL('image/png'))
            }

            image.src = url
        },
       uploadImage(e) {
            let file = e.target.files[0];
            

            let limit = 1024 * 1024 * 2;
            
            var reader = new FileReader();
            var vm = this;

            vm.formData.foto = file;
            reader.onload = (file) => {
                vm.lihat_foto = reader.result;
            };

            reader.readAsDataURL(file)
        },
        uploadFlyer(e) {
            let file = e.target.files[0];
            
            if(e.target.files[0].type != "image/png" && e.target.files[0].type != "image/jpeg") {
                this.alertError("Format Flyer Harus PNG/JPG");
                this.$refs.uploadDokumenPendukung.value = null;
                
                return false;
            }

            let limit = 1024 * 1024 * 2;
            
            var reader = new FileReader();
            var vm = this;
            vm.formData.flyer = file;

            reader.onload = (file) => {
                let img = new Image();
                img.src = reader.result

                vm.lihat_foto = reader.result;
            };

            reader.readAsDataURL(file)
            


            
        }
    }
};